import React from 'react';
import Separator from '@/components/atoms/separator';

const SeparatorTastic = () => {
  return <Separator />;
};

export default SeparatorTastic;
